import { DEFAULT_PORTAL_MODULES, type Me, type PortalModuleKey } from '@briary/shared'

export function canUsePortalModule(me: Me | null, key: PortalModuleKey): boolean {
  if (!me) return false
  if (me.isSuperadmin || me.areas.includes('admin')) return true
  return me.areas.includes('portal') && (me.portalModules ?? DEFAULT_PORTAL_MODULES)[key] === true
}

export function moduleForPortalPath(path: string): PortalModuleKey | null {
  const routes: [string, PortalModuleKey][] = [
    ['/portal/photos/declarations', 'alternativeEvidence'], ['/portal/air-tests', 'airTesting'],
    ['/portal/hem', 'hem'], ['/portal/site-metrics', 'siteMetrics'], ['/portal/models', 'sketchupModels'],
    ['/portal/epc', 'epc'], ['/portal/requests', 'workRequests'],
    ['/portal/health-safety', 'healthSafety'], ['/portal/feedback', 'feedback'],
  ]
  return routes.find(([prefix]) => path === prefix || path.startsWith(prefix + '/'))?.[1] ?? null
}

export function canOpenPortalPath(me: Me | null, path: string): boolean {
  const module = moduleForPortalPath(path)
  return module === null || canUsePortalModule(me, module)
}
